import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiService } from "../../utils/api";
import { 
  FaFileAlt, 
  FaSearch, 
  FaFilter, 
  FaSortAmountDown, 
  FaSortAmountUp, 
  FaPlus,
  FaEye,
  FaDownload,
  FaTrash
} from "react-icons/fa";
import "./TeacherStyles.css";

function MyDocument() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [filterType, setFilterType] = useState("all");
  const navigate = useNavigate();

  useEffect(() => {
    console.log("MyDocument component mounted");
    fetchDocuments();
  }, [sortOrder, filterType]);

  const fetchDocuments = async () => {
    console.log("Fetching documents...");
    setLoading(true);
    try {
      // In a real implementation, you would call your API with the filter and sort parameters
      const response = await apiService.getTeacherDocuments()
      
      console.log("Documents API response:", response);
      
      if (response && response.data && response.data.success) {
        setDocuments(response.data.documents || []);
      } else {
        console.error("API response unsuccessful:", response);
        setError("Failed to load documents");
      }
    } catch (err) {
      console.error("Documents fetch error:", err);
      setError("Error fetching documents: " + (err.response?.data?.message || err.message || "Unknown error"));
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const handleFilterChange = (e) => {
    setFilterType(e.target.value);
  };

  const handleViewDocument = (id) => {
    navigate(`/dashboard/teacher/documents/${id}`);
  };

  const handleScanDocument = () => {
    navigate("/dashboard/teacher/scan");
  };

  const handleDownloadDocument = (id, e) => {
    e.stopPropagation(); // Prevent triggering the card click
    // Implement document download logic
    console.log("Downloading document:", id);
  };

  const handleDeleteDocument = (id, e) => {
    e.stopPropagation(); // Prevent triggering the card click
    // Implement document deletion logic with confirmation
    if (window.confirm("Are you sure you want to delete this document?")) {
      console.log("Deleting document:", id);
    }
  };

  // Filter documents based on search term
  const filteredDocuments = documents.filter(doc => 
    doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (doc.description && doc.description.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div className="documents-container">
      <div className="section-header">
        <h2>My Documents</h2>
        <div className="section-actions">
          <div className="search-bar">
            <FaSearch />
            <input 
              type="text" 
              placeholder="Search documents..." 
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
          {/* <div className="filter-controls">
            <div className="filter-group">
              <FaFilter />
              <select value={filterType} onChange={handleFilterChange}>
                <option value="all">All Types</option>
                <option value="written">Written</option>
                <option value="pdf">PDF</option>
                <option value="image">Image</option>
              </select>
            </div>
            <button className="sort-button" onClick={toggleSortOrder}>
              {sortOrder === "asc" ? <FaSortAmountUp /> : <FaSortAmountDown />}
            </button>
          </div> */}
          <button className="action-button scan-button" onClick={handleScanDocument}>
            <FaPlus /> Scan New Document
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loading-spinner"></div>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : filteredDocuments.length === 0 ? (
        <div className="empty-message">
          <FaFileAlt className="empty-icon" />
          <p>No documents found. Start by scanning a document.</p>
          <button className="action-button scan-button" onClick={handleScanDocument}>
            <FaPlus /> Scan New Document
          </button>
        </div>
      ) : (
        <div className="documents-grid">
          {filteredDocuments.map((doc) => (
            <div key={doc.id} className="document-card" onClick={() => handleViewDocument(doc.id)}>
              <div className="document-icon">
                <FaFileAlt />
              </div>
              <div className="document-info">
                <h4>{doc.title}</h4>
                <p className="document-type">Batch: {doc?.Batch?.name}</p>
                <p className="document-date">Created: {new Date(doc.createdAt).toLocaleDateString()}</p>
                {doc.description && <p className="document-description">{doc.description}</p>}
              </div>
              {/* <div className="document-actions">
                <button className="icon-button view-button" onClick={(e) => handleViewDocument(doc.id)}>
                  <FaEye />
                </button>
                <button className="icon-button download-button" onClick={(e) => handleDownloadDocument(doc.id, e)}>
                  <FaDownload />
                </button>
                <button className="icon-button delete-button" onClick={(e) => handleDeleteDocument(doc.id, e)}>
                  <FaTrash />
                </button>
              </div> */}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MyDocument;